import { saveFcmToken } from "@/api";

export function healthCheckAndroid() {
  return !!window.HYBRID_ANDROID;
}

export function healthCheckIOS() {
  return (
    typeof window.webkit !== "undefined" &&
    !!window.webkit?.messageHandlers?.HYBRID_IOS
  );
}

export function isOnHybridApp() {
  return healthCheckAndroid() || healthCheckIOS();
}

export function getFcmToken() {
  if (healthCheckAndroid()) {
    window.HYBRID_ANDROID.getFcmToken();
  } else if (healthCheckIOS()) {
    window.webkit.messageHandlers.HYBRID_IOS.postMessage("getFcmToken");
  }
}

export function getUserPhoneInfo() {
  if (healthCheckAndroid()) {
    window.HYBRID_ANDROID.getUserPhoneInfo();
  } else if (healthCheckIOS()) {
    window.webkit.messageHandlers.HYBRID_IOS.postMessage("getUserPhoneInfo");
  }
}

export function mainMountOk() {
  if (healthCheckAndroid()) {
    window.HYBRID_ANDROID.mainMountOk();
  } else if (healthCheckIOS()) {
    // window.webkit.messageHandlers.HYBRID_IOS.postMessage("mainMountOk");
  }
}

// 어플 토큰 저장
window.getFcmTokenResult = async function (arg_fcm_token) {
  await saveFcmToken({
    token: arg_fcm_token,
  });
};
